<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title class="ml4">Youtube Videos </nz-page-header-title>
    <nz-page-header-extra class="mr4">
      <button
        nz-button
        nzType="primary"
        [nzLoading]="syncing"
        (click)="syncVideos()"
      >
        <i nz-icon nzType="sync"></i> Sync Videos
      </button>
    </nz-page-header-extra>
  </nz-page-header>
</div>

<nz-card class="mt3">
  <nz-tabset [(nzSelectedIndex)]="tabIndex">
    <!-- ===================== VIDEOS TAB ===================== -->
    <nz-tab nzTitle="Videos">
      <ng-template nz-tab>
        <nz-table
          #basicTable
          [nzData]="videos"
          [nzLoading]="loading"
          [nzFrontPagination]="false"
          [nzTotal]="totalCount"
          [(nzPageSize)]="pageSize"
          [nzPageIndex]="pageIndex"
          (nzQueryParams)="onQueryParamsChange($event)"
          nzShowSizeChanger
        >
          <thead>
            <tr>
              <th nzWidth="120px">Thumbnail</th>
              <th>Title</th>
              <th nzWidth="90px">Views</th>
              <th nzWidth="90px">Likes</th>
              <th nzWidth="90px">Dislikes</th>
              <th nzWidth="100px">Comments</th>
              <th>Published At</th>
              <th nzWidth="320px" class="text-right">Action</th>
            </tr>
          </thead>
          <tbody cdkDropList (cdkDropListDropped)="onDropVideos($event)">
            <tr
              *ngFor="let item of basicTable.data"
              cdkDrag
              [cdkDragData]="item"
              style="cursor: grab"
            >
              <td>
                <img
                  *ngIf="getThumbnail(item)"
                  [src]="getThumbnail(item)"
                  alt="thumbnail"
                  style="
                    width: 100px;
                    height: 60px;
                    object-fit: cover;
                    border-radius: 4px;
                  "
                />
              </td>
              <td>{{ item.title || "N/A" }}</td>
              <td>{{ getViewCount(item) | number }}</td>
              <td>{{ getLikeCount(item) | number }}</td>
              <td>{{ getDislikeCount(item) | number }}</td>
              <td>{{ getCommentCount(item) | number }}</td>
              <td>{{ item.publishedTime | date: "mediumDate" }}</td>
              <td class="action-buttons">
                <a
                  nz-button
                  nzType="primary"
                  nz-tooltip
                  nzTooltipTitle="Preview"
                  (click)="openPreview(item)"
                >
                  <i nz-icon nzType="play-circle"></i>
                </a>
                <a
                  nz-button
                  nzType="primary"
                  [href]="getWatchUrl(item)"
                  target="_blank"
                  nzDanger
                  rel="noopener"
                  nz-tooltip
                  nzTooltipTitle="Open in Youtube"
                >
                  <i nz-icon nzType="youtube"></i>
                </a>
                <a
                  class="action-button"
                  nz-button
                  nzType="default"
                  [nzDanger]="item.status"
                  nz-popconfirm
                  nzPopconfirmTitle="Are you sure {{
                    item.status ? 'deActive' : 'active'
                  }} this Video?"
                  (nzOnConfirm)="updateStatus(item._id, item.status)"
                  nzTooltipTitle="{{ item.status ? 'Deactive' : 'Active' }}"
                  nzTooltipPlacement="topRight"
                  nz-tooltip
                  ><i
                    nz-icon
                    [nzType]="item.status ? 'stop' : 'check'"
                    nzTheme="outline"
                  ></i
                ></a>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </ng-template>
    </nz-tab>

    <!-- ===================== PLAYLISTS TAB ===================== -->
    <nz-tab nzTitle="Playlists">
      <ng-template nz-tab>
        <nz-table
          #playlistTable
          [nzData]="playlists"
          [nzLoading]="playlistLoading"
          [nzFrontPagination]="false"
          [nzTotal]="playlistTotalCount"
          [(nzPageSize)]="playlistPageSize"
          [nzPageIndex]="playlistPageIndex"
          (nzQueryParams)="onPlaylistQueryParamsChange($event)"
          nzShowSizeChanger
        >
          <thead>
            <tr>
              <th nzWidth="40px"></th>
              <th nzWidth="120px">Thumbnail</th>
              <th>Playlist</th>
              <th nzWidth="120px">No. of Videos</th>
              <th>Created At</th>
              <th nzWidth="120px" class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let pl of playlistTable.data">
              <tr>
                <td [(nzExpand)]="pl.expand"></td>
                <td>
                  <img
                    *ngIf="getPlaylistThumbnail(pl)"
                    [src]="getPlaylistThumbnail(pl)"
                    alt="thumbnail"
                    style="
                      width: 100px;
                      height: 60px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                  />
                </td>
                <td>
                  <a
                    [href]="getPlaylistUrl(pl)"
                    target="_blank"
                    rel="noopener"
                    nz-tooltip
                    nzTooltipTitle="Open playlist on YouTube"
                  >
                    {{ getPlaylistTitle(pl) }}
                    <i nz-icon nzType="link" nzTheme="outline"></i>
                  </a>
                </td>
                <td>{{ getPlaylistVideoCount(pl) | number }}</td>
                <td>{{ pl.createdAt | date: "mediumDate" }}</td>
                <td class="action-buttons text-right">
                  <a
                    class="action-button"
                    nz-button
                    nzType="default"
                    [nzDanger]="pl.status"
                    nz-popconfirm
                    nzPopconfirmTitle="Are you sure {{
                      pl.status ? 'deActive' : 'active'
                    }} this Playlist?"
                    (nzOnConfirm)="updatePlaylistStatus(pl._id, pl.status)"
                    nzTooltipTitle="{{ pl.status ? 'Deactive' : 'Active' }}"
                    nzTooltipPlacement="topRight"
                    nz-tooltip
                    ><i
                      nz-icon
                      [nzType]="pl.status ? 'stop' : 'check'"
                      nzTheme="outline"
                    ></i
                  ></a>
                </td>
              </tr>
              <tr [nzExpand]="pl.expand">
                <td [attr.colspan]="6">
                  <div class="playlist-videos">
                    <nz-table
                      #plVideos
                      [nzData]="getPlaylistVideos(pl)"
                      [nzPageSize]="10"
                      nzSize="small"
                    >
                      <thead>
                        <ng-container
                          *ngTemplateOutlet="videoHead"
                        ></ng-container>
                      </thead>
                      <tbody>
                        <ng-container
                          *ngTemplateOutlet="
                            videoRows;
                            context: { $implicit: plVideos.data }
                          "
                        ></ng-container>
                      </tbody>
                    </nz-table>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </nz-table>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</nz-card>

<!-- ===================== SHARED VIDEO TABLE TEMPLATES ===================== -->
<ng-template #videoHead>
  <tr>
    <th nzWidth="120px">Thumbnail</th>
    <th>Title</th>
    <th nzWidth="90px">Views</th>
    <th nzWidth="90px">Likes</th>
    <th nzWidth="90px">Dislikes</th>
    <th nzWidth="100px">Comments</th>
    <th>Published At</th>
    <th nzWidth="320px" class="text-right">Action</th>
  </tr>
</ng-template>

<ng-template #videoRows let-rows>
  <tr *ngFor="let item of rows" cdkDrag style="cursor: grab">
    <td>
      <img
        *ngIf="getThumbnail(item)"
        [src]="getThumbnail(item)"
        alt="thumbnail"
        style="
          width: 100px;
          height: 60px;
          object-fit: cover;
          border-radius: 4px;
        "
      />
    </td>
    <td>{{ item.title || "N/A" }}</td>
    <td>{{ getViewCount(item) | number }}</td>
    <td>{{ getLikeCount(item) | number }}</td>
    <td>{{ getDislikeCount(item) | number }}</td>
    <td>{{ getCommentCount(item) | number }}</td>
    <td>{{ item.publishedTime | date: "mediumDate" }}</td>
    <td class="action-buttons">
      <a
        nz-button
        nzType="primary"
        nz-tooltip
        nzTooltipTitle="Preview"
        (click)="openPreview(item)"
      >
        <i nz-icon nzType="play-circle"></i>
      </a>
      <a
        nz-button
        nzType="primary"
        [href]="getWatchUrl(item)"
        target="_blank"
        nzDanger
        rel="noopener"
        nz-tooltip
        nzTooltipTitle="Open in Youtube"
      >
        <i nz-icon nzType="youtube"></i>
      </a>
      <a
        class="action-button"
        nz-button
        nzType="default"
        [nzDanger]="item.status"
        nz-popconfirm
        nzPopconfirmTitle="Are you sure {{
          item.status ? 'deActive' : 'active'
        }} this Video?"
        (nzOnConfirm)="updateStatus(item._id, item.status)"
        nzTooltipTitle="{{ item.status ? 'Deactive' : 'Active' }}"
        nzTooltipPlacement="topRight"
        nz-tooltip
        ><i
          nz-icon
          [nzType]="item.status ? 'stop' : 'check'"
          nzTheme="outline"
        ></i
      ></a>
    </td>
  </tr>
</ng-template>

<nz-modal
  [(nzVisible)]="previewVisible"
  [nzTitle]="previewTitle"
  [nzFooter]="null"
  nzWidth="760px"
  (nzOnCancel)="closePreview()"
>
  <ng-container *nzModalContent>
    <div class="video-frame-wrapper" *ngIf="previewUrl">
      <iframe
        [src]="previewUrl"
        frameborder="0"
        allow="
          accelerometer;
          autoplay;
          clipboard-write;
          encrypted-media;
          gyroscope;
          picture-in-picture;
        "
        allowfullscreen
      ></iframe>
    </div>
  </ng-container>
</nz-modal>
